module.exports = __webpack_public_path__ + "media/images/homepage/vector3-62df83fcf2aa1b304b87e9a9d74d4830.png";